import { includes } from '../ignore-case';

// Pickup
// PickupWithTrade
// LocalDelivery
// LocalDeliveryWithTrade
// DirectDelivery

const ScheduleType = (deliveryPreference = null) => {
  const isDelivery = includes('delivery', deliveryPreference);
  const isPickup = includes('pickup', deliveryPreference);
  const isDirectDelivery = includes('directdelivery', deliveryPreference);

  return { isDelivery, isPickup, isDirectDelivery, deliveryPreference };
};

export default ScheduleType;
